<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Customers',
          routeName: 'customers'
        }]"
        title="Create"
      />
      <h1>
        Create Customer
      </h1>
      <CustomerEditor v-model:value="customer" />
      <h2>
        Contact Details
      </h2>
      <ContactDetailsList
        v-if="customer.contactDetails"
        v-model:items="customer.contactDetails.records"
        v-model:selectedIndex="selectedContactDetailsIndex"
        @select="selectedContactDetails = customer.contactDetails.records[selectedContactDetailsIndex]"
      />
      <ContentModal v-if="selectedContactDetails">
        <ContactDetailsEditor v-model:value="selectedContactDetails" />
        <br>
        <Button
          title="Apply"
          @click="selectedContactDetails = null"
        />
      </ContentModal>
      <Button
        title="Cancel"
        @click="customerRedirect()"
      />
      <Button
        title="Save"
        @click="save()"
      />
    </VerticalNavigator>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import CustomerEditor from "@/components/editors/customer.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Customer as CustomerResolver} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import {ContactDetails as ContactDetailsResolver} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {ref} from "vue"
  import {
    ContactDetails,
    Customer,
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import ErrorModal from "@/components/modals/error.vue"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContentModal from "@/components/modals/content.vue"

  const error = ref<Error>(null)
  const customerResolver = new CustomerResolver()
  const contactDetailsResolver = new ContactDetailsResolver()
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const customer = ref<Customer>({
    contactDetails: {
      records: [],
    }
  })

  async function save() {
    try {
      const customerID = await customerResolver.create(customer.value)
      if (customer.value.contactDetails && customer.value.contactDetails.records) {
        for (const contactDetails of customer.value.contactDetails.records) {
          if (contactDetails.deletedAt) {
            continue
          }
          contactDetails.relationID = customerID
          contactDetails.relationType = "CUSTOMER"
          await contactDetailsResolver.create(contactDetails)
        }
      }
      customerRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function customerRedirect() {
    router.push({
      name: "customers"
    })
  }
</script>
